export enum LS {
  USER_TOKEN = 'USER_TOKEN',
  USER_TOKEN_TIME = 'USER_TOKEN_TIME',
  USER_REFRESH_TOKEN = 'USER_REFRESH_TOKEN',
  USER_EMAIL = 'USER_EMAIL',
  USER_FULLNAME = 'USER_FULLNAME',

  MERCHANT_LIST = 'MERCHANT_LIST',
  MERCHANT_ACTIVE = 'MERCHANT_ACTIVE',
  LIVE_MERCHANT_LIST = 'LIVE_MERCHANT_LIST',
  MERCHANT_GROUP_LIST = 'MERCHANT_GROUP_LIST',

  DATETIMEPICKER_DATE_START = 'DATETIMEPICKER_DATE_START',
  DATETIMEPICKER_DATE_END = 'DATETIMEPICKER_DATE_END',
  DATETIMEPICKER_NAME = 'DATETIMEPICKER_NAME',

  SUMMARY_FILTER_PAYMENT_METHOD = 'SUMMARY_FILTER_PAYMENT_METHOD',
  SUMMARY_FILTER_PAYMENT_CHANNEL = 'SUMMARY_FILTER_PAYMENT_CHANNEL',
  SUMMARY_FILTER_BANK = 'SUMMARY_FILTER_BANK',

  EMAIL_LOGIN = 'EMAIL_LOGIN',
  EMAIL_REGISTER = 'EMAIL_REGISTER',

  LAST_URL = 'LAST_URL',
  CLIENT_INFO = 'CLIENT_INFO',
  ROLE = 'ROLE',
  ROLE_ID = 'ROLE_ID',

  MENU_LIST = 'MENU_LIST',
  ACTION_LIST = 'ACTION_LIST',
  PERMISSION_LIST = 'PERMISSION_LIST',

  MFA_OTP_CHANGE_EMAIL_MAP = 'MFA_OTP_CHANGE_EMAIL_MAP',
  MFA_OTP_CHANGE_PASSWORD_MAP = 'MFA_OTP_CHANGE_PASSWORD_MAP',
  NOTIFICATION_DISPLAY = 'NOTIFICATION_DISPLAY',
}
